// extracted by mini-css-extract-plugin
module.exports = {"title":"PasswordResetSent_title__3m7gg","continueButtonBlock":"PasswordResetSent_continueButtonBlock__1H6ev"};